import request from './request.js'

/**
 * 定义 GET 与 POST 请求
 */

export function login(loginName, password, loginType) {
    return request({
      url: 'xlmonitor_web/login/sign',
      method: 'get',
      params: {
        loginName,
        password,
        loginType
      }
    })
  }



// WEBPACK FOOTER //
// ./src/util/unit/api.js